import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { PaginatorModule } from 'primeng/paginator';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { ComunesModule } from '../../_comunes/comunes.module';
import { CampaniaEspecificaWrapperComponent } from './campaniasespecificas/campaniaespecifica-wrapper/campaniaespecifica-wrapper.component';
import { CampaniaEspecificaWrapperEditComponent } from './campaniasespecificas/campaniaespecifica-wrapper-edit/campaniaespecifica-wrapper-edit.component';
import { CampaniaEspecificaEditComponent } from './campaniasespecificas/campaniaespecifica-edit/campaniaespecifica-edit.component';
import { CampaniaEspecificaFilterComponent } from './campaniasespecificas/campaniaespecifica-filter/campaniaespecifica-filter.component';
import { CampaniaEspecificaListComponent } from './campaniasespecificas/campaniaespecifica-list/campaniaespecifica-list.component';
import { CampaniaEspecificaService } from './campaniasespecificas/campaniaespecifica.service';
import { DocumentacionCamWrapperComponent } from './campania/documentacioncam/documentacioncam-wrapper/documentacioncam-wrapper.component';
import { DocumentacionCamUpdateComponent } from './campania/documentacioncam/documentacioncam-update/documentacioncam-update.component';
import { DocumentacionCamListComponent } from './campania/documentacioncam/documentacioncam-list/documentacioncam-list.component';
import { DocumentacionCamService } from './campania/documentacioncam/documentacioncam.service';
import { PeriodosModule } from './periodos/periodos.module';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { AforosModule } from './aforos/aforos.module';
@NgModule({
    declarations: [
        CampaniaEspecificaWrapperEditComponent,
        CampaniaEspecificaWrapperComponent,
        CampaniaEspecificaListComponent,
        CampaniaEspecificaFilterComponent,
        CampaniaEspecificaEditComponent,

        DocumentacionCamWrapperComponent,
        DocumentacionCamUpdateComponent,
        DocumentacionCamListComponent,
    ],
    imports: [
        ComunesModule,
        AforosModule,
        PeriodosModule,
        CoreModule,
        AppModuleGlobalShared,
        PaginatorModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            // CAMPAÑAS ESPECÍFICAS
            {
                path: 'mantenimiento/campanias',
                data: {
                    breadcrumb: 'Campañas',
                    menu0: 'MANTENIMIENTO',
                },
                children: [
                    {
                        path: '',
                        component: CampaniaEspecificaWrapperComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },

            {
                path: 'mantenimiento/campania',
                data: {
                    breadcrumb: 'Campañas',
                    menu0: 'MANTENIMIENTO',
                    overridePath: 'mantenimiento/campanias',
                },
                children: [
                    {
                        path: 'edit/:id',
                        component: CampaniaEspecificaWrapperEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Editar Campaña Específica',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'create',
                        component: CampaniaEspecificaWrapperEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Crear Campaña Específica',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                    {
                        path: 'documentacion/:idCampania',
                        component: DocumentacionCamWrapperComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            breadcrumb: 'Documentación',
                            actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                        },
                    },
                ],
            },
        ]),
    ],
    providers: [CampaniaEspecificaService, DocumentacionCamService],
})
export class CampaniasMtoModule {}
